module.exports = "/images/img1.png?13e44702dce46f357b099c5e5e1df787";